export default __webpack_public_path__ + "static/media/logo-colored.11b6590f.png";